<template id="glowTemplate">
    <div class="gradient__background--glow">
        <div class="gradient__container--glow">
            <div class="glow1" />
            <div class="glow2" />
            <div class="glow3" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'GlowGradient',
    data() {
        return {
            pause: undefined,
        };
    },
};
</script>

<style lang="scss">
.gradient__background--glow {
    @include glowBackground(rgb(23, 27, 72));
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
}

.gradient__container--glow {
    @include glowContainer(100%, 100%, 120s);
}

.glow1 {
    @include glow(glow1, 10%, 10%, 800px, 800px, 27s, rgb(230, 0, 45));
}

.glow2 {
    @include glow(glow2, 10%, 10%, 800px, 800px, 26s, rgb(230, 0, 45));
}

.glow3 {
    @include glow(glow3, 10%, 10%, 800px, 800px, 28s, rgb(230, 0, 45));
}

</style>



// WEBPACK FOOTER //
// src/components/GlowGradient.vue